// Langue du site : choisie au démarrage (avant le rendu), mémorisée dans le navigateur.
// Importé en tout premier par main.tsx : les autres modules voient déjà la bonne langue.

import { getLang, langFromCode, type Lang, setLang, t } from '@shared/i18n';

const KEY = 'followme-lang';

function storedLang(): Lang | null {
  try {
    const v = localStorage.getItem(KEY);
    return v === 'fr' || v === 'en' ? v : null;
  } catch {
    return null;
  }
}

/** Fixe la langue au démarrage : choix mémorisé, sinon langue du navigateur. */
export function initLang() {
  setLang(storedLang() ?? langFromCode(typeof navigator !== 'undefined' ? navigator.language : null));
  document.documentElement.lang = getLang();
  document.title = t('FollowMe — rallyes routiers', 'FollowMe — road rallies');
}

/** Change de langue : mémorise le choix puis recharge la page (pas de contexte React, c'est voulu). */
export function chooseLang(lang: Lang) {
  try {
    localStorage.setItem(KEY, lang);
  } catch {
    // stockage indisponible (navigation privée…) : la langue vaudra seulement pour ce chargement
    setLang(lang);
  }
  location.reload();
}
